import React, { useEffect } from 'react';
import NavMenu from './Nav/NavMenu';
import Footer from './Footer';
import { ToastContainer } from 'react-toastify';
import { SiteMessage } from './PageComponents';
import { ServiceMessageType } from './Types';
import { useDispatch, useSelector } from 'react-redux';
import { setServiceMessages } from 'features/ServiceMessage-Slice';
import { ServiceMessagesAPI } from 'API/GeneralAPI';
import { RootState } from 'store';

type LayoutProps = {
    children: React.ReactNode;
}

function Layout({ children }: LayoutProps) {

    const { currentEmployee  } = useSelector((state: RootState) => state.auth);
    const { serviceMessages  } = useSelector((state: RootState) => state.serviceMessages);
    const dispatch = useDispatch();
    
    useEffect(() => {
        const getData = async () => {
            const response = await ServiceMessagesAPI.get(currentEmployee?.employer_id);
            dispatch(setServiceMessages(response));
        }
        getData();

    }, [currentEmployee]);
    
    return (
        <>
            <NavMenu/>
            {serviceMessages?.map((sm: ServiceMessageType) => {
                return (<SiteMessage key={sm.message_text}>{sm.message_text}</SiteMessage>);
            })}
            <ToastContainer/>
            {children}
            <Footer />
        </>
    );
}
export default Layout;
